import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import useDataLastOrders from '../../hooks/useDataLastOrders';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import Home from '../Home';
import { themeColors } from '../../styles';
import { useNavigate } from 'react-router-dom';
import URLS from '../../enums/route';
import { DocumentEnum } from '../../types/documentEnum';
import { useTour } from '../../provider/TourGuide';

const LastOrders = () => {
    const {enabledCatalog} = useTour()
    const { data } = useDataLastOrders();
    const navigate = useNavigate()
    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: '20px' }}>
                <Typography fontWeight={700} fontSize={20} lineHeight={'28px'} color={themeColors.title}>
                    הזמנות שביצעת לאחרונה
                </Typography>
                <IconButton onClick={() => navigate(`${URLS.DOCUMENTS.LINK}/${DocumentEnum.ORDERS}`)}>
                    <ArrowBackIosRoundedIcon sx={{ color: themeColors.title }} />
                </IconButton>
            </Box>

            <Box>
                {enabledCatalog &&
                <Box id={"catalog1"}>
                    <Home.Card 
                        item={{
                        documentNumber: "SO25E000XXX",
                        documentType: "orders",
                        orderType: "CON",
                        userName: "משחקים לבדיקת פריוריטי",
                        userExId: "100797",
                        status: "ניתן לשיבוץ!",
                        createdAt: "2025-04-20T00:00:00+03:00",
                        updatedAt: "2025-04-20T00:00:00+03:00",
                        deliveryDate: "2025-04-22T00:00:00+03:00",
                        area: "200",
                        areaDescription: "משחקים לבדיקת פריוריטי",
                        toAreaCode: "משחקים לבדיקת פריוריטי",
                        total: 98.5,
                        machine: "",
                        product: null,
                        totalQuantity: 3,
                        pdf: "",
                        sku: "",
                        description: "",
                        comment: "",
                        items: [],
                        files: [],
                        questionDoc: "",
                        tags: [],
                    }}
                        isOrder={true} 
                    />
                </Box>
        
                }
                {data?.slice(0, 2).map((item) => (
                    <Home.Card key={item.documentNumber} item={item} isOrder={true} />
                ))}
            </Box>
        </Box>
    );
};

export default LastOrders;
